import React from 'react';
import { techniques } from '../data/landing';
export function Revelation() {
  return <section className="w-full bg-plum text-cream" aria-labelledby="kit-titulo" data-id="element-95" data-mp="3szs0j3vuofaa">
      <div className="mx-auto grid max-w-content grid-cols-1 items-center gap-12 px-6 py-16 md:py-24 lg:grid-cols-12" data-id="element-96" data-mp="1tqoot429hnl">
        <div className="order-2 lg:order-1 lg:col-span-4" data-id="element-97" data-mp="6kyyvrd7t71t">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/b9b71415-132a-4e14-a401-d1f76d066196.jpg" alt="Mapa corporal con los centros energéticos y sus flujos señalados" className="w-full rounded-2xl bg-cream object-cover" data-id="element-98" data-mp="6mjrvcjvshxk" />
        </div>

        <div className="order-1 lg:order-2 lg:col-span-8" data-id="element-99" data-mp="ki5h9ku113qi">
          <p className="font-sans text-sm text-sand/70" data-id="element-100" data-mp="pi9t2xjzpaae">Presentamos</p>
          <h2 id="kit-titulo" className="mt-3 font-display text-3xl font-semibold leading-tight sm:text-4xl lg:text-5xl" data-id="element-101" data-mp="2mc4onv4130xx">
            Kit Maestro de Evaluación Energética
          </h2>

          <p className="mt-6 max-w-2xl font-sans text-lg leading-relaxed text-cream/80" data-id="element-102" data-mp="3hit9td6xj38h">
            Una herramienta visual y técnica para que tengas el control total de
            la sesión. Se adapta a tu técnica para darte el mapa exacto de lo
            que el cuerpo de tu paciente está gritando.
          </p>

          <ul className="mt-7 flex flex-wrap gap-2" aria-label="Técnicas compatibles" data-id="element-103" data-mp="33ry05yolwi3u">
            {techniques.map(technique => <li key={technique} className="rounded-full border border-cream/25 px-4 py-1.5 font-sans text-sm text-cream/90" data-id="element-104" data-mp="3vhj8gx9edayy">
                {technique}
              </li>)}
          </ul>

          <p className="mt-7 max-w-2xl font-display text-xl font-semibold leading-snug text-clay" data-id="element-105" data-mp="3mg2wil2xp0sm">
            Aprendé a leer el campo energético con la precisión de un experto y
            da devoluciones que dejen a tus pacientes impactados.
          </p>
        </div>
      </div>
    </section>;
}